import React from "react";
import { Chip } from "@mui/material";
import { PETICION_TIPO } from "../../constants";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";

/**
 * Badge diferenciado por tipo de petición.
 * El tipo es un metadato categórico (no un estado): se usa color identificativo
 * sin carga de alarma.
 * PETICION: Azul (flujo estándar de cliente con albarán)
 * REPOSICION: Púrpura (acción preventiva interna sin albarán)
 */
export default function TipoBadge({ tipo, size = "normal" }) {
    const esReposicion = tipo === PETICION_TIPO.REPOSICION.value;

    // Tamaños: normal (desktop) o small (mobile)
    const isSmall = size === "small";
    const height = isSmall ? 20 : 24;
    const fontSize = isSmall ? 10 : 11;

    // Color según tipo
    const color = esReposicion ? BADGE_COLORS.PURPLE : BADGE_COLORS.BLUE;

    return (
        <Chip
            label={esReposicion ? 'Reposición' : 'Petición'}
            size="small"
            sx={getBadgeStyles(color, { height, fontSize })}
        />
    );
}
